export default "__VITE_ASSET__XGGWs66q__"